import { GetAppConfig, GetLanguages, GetJurisdictions } from '../actions/app';

export default (store) => {
    store.dispatch(GetAppConfig());
    store.dispatch(GetLanguages());
    store.dispatch(GetJurisdictions());
};
